import { Fragment } from 'react';
import './App.css';
import { Route, Routes } from 'react-router-dom';
import { Header } from './components/header/header';
import { Home } from './Home/home';

function App() {
  return (
    <Fragment>
      <Routes >
        <Route
          path='/'
          element={
            <div>
              <Header />
              <Home />
            </div>
          } />

      </Routes>
    </Fragment>
  );
}

export default App;
